import { render, staticRenderFns } from "./TaxonomyItem.vue?vue&type=template&id=fc74d4c4&"
import script from "./TaxonomyItem.vue?vue&type=script&lang=js&"
export * from "./TaxonomyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports